import { render, staticRenderFns } from "./ChannelGroupEdit.vue?vue&type=template&id=91aa0406"
import script from "./ChannelGroupEdit.vue?vue&type=script&lang=js"
export * from "./ChannelGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports